import middleware from "../../../shared/middleware";

const { updateBookmark, createBookmark } = middleware;

export const updateBookmarkAPI = (appProvider, type, activeContentId, bookmarkSetId, buildBookmarkCallback) => {
  // Update bookmark API
  return updateBookmark(appProvider, type, activeContentId, bookmarkSetId, {
    bookmark: buildBookmarkCallback(true),
  }).catch((err) => {
    console.error(err);
  });
};

export const createBookmarkAPI = (appProvider, type, activeContentId, buildBookmarkCallback) => {
  // Create bookmark API
  return createBookmark(appProvider, type, activeContentId, { bookmark: buildBookmarkCallback() }).catch((err) => {
    console.error(err);
  });
};
